import React from "react";
import { useLang } from "../LanguageContext";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-ink text-white/70 border-t border-white/10">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-14">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <div className="flex items-center gap-2">
              <img src="/horns-logo-dark.webp" alt="Horns Industriservice" className="h-9 w-auto" />
            </div>
            <p className="mt-4 text-sm font-light max-w-xs">{t.footer.tagline}</p>
          </div>
          <div className="flex gap-10 text-sm font-light">
            <button onClick={() => document.getElementById("products")?.scrollIntoView({ behavior: "smooth" })} className="hover:text-gold-light transition-colors">{t.nav.collections}</button>
            <button onClick={() => document.getElementById("about")?.scrollIntoView({ behavior: "smooth" })} className="hover:text-gold-light transition-colors">{t.nav.about}</button>
            <button onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })} className="hover:text-gold-light transition-colors">{t.nav.contact}</button>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs font-light text-white/45">
          <span>© {year} Horns Industriservice AB. {t.footer.rights}</span>
          <span>Sverige</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
